/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTeamsTeamidInvitationsQueryResponse,
  GetTeamsTeamidInvitationsPathParams,
  GetTeamsTeamidInvitations401,
  GetTeamsTeamidInvitations403,
  GetTeamsTeamidInvitations500,
} from "../types/GetTeamsTeamidInvitations.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTeamsTeamidInvitationsQueryKey = (
  teamId: GetTeamsTeamidInvitationsPathParams["teamId"] | undefined,
) =>
  [{ url: "/teams/:teamId/invitations", params: { teamId: teamId } }] as const;

export type GetTeamsTeamidInvitationsQueryKey = ReturnType<
  typeof getTeamsTeamidInvitationsQueryKey
>;

/**
 * @description Возвращает все отправленные командой приглашения.
 * Показывает статус каждого приглашения (Pending, Accepted, Declined).
 * @summary Получить все приглашения команды
 * {@link /teams/:teamId/invitations}
 */
export async function getTeamsTeamidInvitations(
  teamId: GetTeamsTeamidInvitationsPathParams["teamId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTeamsTeamidInvitationsQueryResponse,
    ResponseErrorConfig<
      | GetTeamsTeamidInvitations401
      | GetTeamsTeamidInvitations403
      | GetTeamsTeamidInvitations500
    >,
    unknown
  >({ method: "GET", url: `/teams/${teamId}/invitations`, ...requestConfig });
  return res;
}

export function getTeamsTeamidInvitationsQueryOptions(
  teamId: GetTeamsTeamidInvitationsPathParams["teamId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTeamsTeamidInvitationsQueryKey(teamId);
  return queryOptions<
    ResponseConfig<GetTeamsTeamidInvitationsQueryResponse>,
    ResponseErrorConfig<
      | GetTeamsTeamidInvitations401
      | GetTeamsTeamidInvitations403
      | GetTeamsTeamidInvitations500
    >,
    ResponseConfig<GetTeamsTeamidInvitationsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!teamId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTeamsTeamidInvitations(teamId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Возвращает все отправленные командой приглашения.
 * Показывает статус каждого приглашения (Pending, Accepted, Declined).
 * @summary Получить все приглашения команды
 * {@link /teams/:teamId/invitations}
 */
export function useGetTeamsTeamidInvitations<
  TData = ResponseConfig<GetTeamsTeamidInvitationsQueryResponse>,
  TQueryData = ResponseConfig<GetTeamsTeamidInvitationsQueryResponse>,
  TQueryKey extends QueryKey = GetTeamsTeamidInvitationsQueryKey,
>(
  teamId: GetTeamsTeamidInvitationsPathParams["teamId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTeamsTeamidInvitationsQueryResponse>,
        ResponseErrorConfig<
          | GetTeamsTeamidInvitations401
          | GetTeamsTeamidInvitations403
          | GetTeamsTeamidInvitations500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getTeamsTeamidInvitationsQueryKey(teamId);

  const query = useQuery(
    {
      ...getTeamsTeamidInvitationsQueryOptions(teamId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetTeamsTeamidInvitations401
      | GetTeamsTeamidInvitations403
      | GetTeamsTeamidInvitations500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
